import {
  HStack,
  Skeleton,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useContextTypeSettingsOrganization } from "../dashboard-layout";
import { stringMapSettingsOrganizationTab } from "../../../strings";
import Team from "./team";
import BexioSettings from "./bexio-settings";
import { useEffect } from "react";
import { showSettings } from "../../../utils";
import { routeSettingsOrganization } from "../../routes";

const settingsOrganizationTab = ["team", "bexio"] as const;

export type SettingsOrganizationTab = (typeof settingsOrganizationTab)[number];

const SettingsOrganizationLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine the index of the active tab based on the current route
  const activeTabIndex = settingsOrganizationTab.findIndex((t) =>
    location.pathname.includes(t)
  );

  const handleTabsChange = (index: number) => {
    navigate(`${routeSettingsOrganization}/${settingsOrganizationTab[index]}`);
  };

  const { user, selectedOrganization } = useContextTypeSettingsOrganization();

  useEffect(() => {
    // Redirect to the first tab if the current path doesn't match any tab or is the root route
    if (
      activeTabIndex === -1 ||
      location.pathname === routeSettingsOrganization
    ) {
      navigate(`${routeSettingsOrganization}/${settingsOrganizationTab[0]}`);
    }
  }, [activeTabIndex, location.pathname, navigate]);

  if (
    user &&
    selectedOrganization &&
    !showSettings(user, selectedOrganization)
  ) {
    return <Navigate to="/" />;
  }

  return (
    <VStack
      width="full"
      height="full"
      alignItems="start"
      spacing="24px"
      py="24px"
    >
      <HStack>
        <Text fontSize={24} fontWeight="semibold" color="gray.900">
          Einstellungen
        </Text>
        {selectedOrganization ? (
          <Text fontSize={24} fontWeight="semibold" color="gray.900">
            {selectedOrganization.name}
          </Text>
        ) : (
          <Skeleton height="36px" width="120px" />
        )}
      </HStack>
      <Tabs
        width="full"
        height="full"
        variant="soft-rounded"
        colorScheme="primary"
        isLazy
        index={activeTabIndex}
        onChange={handleTabsChange}
      >
        <TabList>
          {settingsOrganizationTab.map((t: SettingsOrganizationTab) => (
            <Tab key={t} borderRadius={6}>
              {stringMapSettingsOrganizationTab.get(t)}{" "}
            </Tab>
          ))}
        </TabList>
        <TabPanels height="full">
          {settingsOrganizationTab.map((t: SettingsOrganizationTab) => (
            <TabPanel key={t} height="full">
              {t === "team" ? (
                <Team />
              ) : t === "bexio" ? (
                <BexioSettings />
              ) : (
                <></>
              )}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </VStack>
  );
};

export default SettingsOrganizationLayout;
